export enum CropGroupValues {
  CEREALS = 'Graudaugi',
  GRASSLANDS = 'Zālāji',
  LEGUMES_INCLUDING_PULSES = 'Tauriņzieži, tai skaitā pākšaugi tīrsējā',
  GREEN_MASS_PLANTS_AND_FODDER_ROOTS = 'Zaļmasas augi un lopbarības sakņaugi',
  OIL_PLANTS_AND_FIBER_PLANTS = 'Eļļas augi un šķiedraugi',
  VEGETABLES = 'Dārzeņi',
  FRUITS_AND_BERRIES_1_TO_3_YEARS = 'Augļi un ogas (1-3 gadi)',
  FRUITS_AND_BERRIES_4_AND_MORE_YEARS = 'Augļi un ogas (4 gadi <…)',
  SHORT_ROTATION_COPPICE_BIOENERGY_CROPS = 'Īscirtmeta atvasāji, enerģijas augi',
  HERBS_AND_CULTIVATED_MEDICINAL_PLANTS = 'Garšaugi un kultivēti ārstniecības augi',
  OTHERS = 'Pārējie',
}
